// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanMilestoneDetailsPageQueryVariables = Types.Exact<{
  planMilestoneId: Types.Scalars['ID']['input'];
}>;


export type PlanMilestoneDetailsPageQuery = { __typename?: 'Query', planMilestone: { __typename?: 'PlanMilestone', id: string, name: string, estStartDate?: Types.Scalars['Date']['input'] | null | undefined, estEndDate?: Types.Scalars['Date']['input'] | null | undefined, durationInDays: number, progress: number, confidence: number, allowingPlanTasks: Array<{ __typename?: 'PlanTask', id: string, name: string, startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], status: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string }, constraintItems: Array<{ __typename?: 'GlobalPlanConstraintItem', id: string }>, simulationProbability: { __typename?: 'SimulationProbability', endDateBasisPoints?: number | null | undefined } }>, planSchedule: { __typename?: 'PlanSchedule', id: string, parent:
        | { __typename?: 'StandaloneProject', id: string, name: string, buildAddress: { __typename?: 'Address', id: string, street1: string } }
        | { __typename?: 'Region', id: string, name: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined }
        | { __typename?: 'Market', id: string, name: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined }
        | { __typename?: 'Community', id: string, name: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined }
        | { __typename?: 'Subdivision', id: string, name: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined }
        | { __typename?: 'Lot', id: string, name: string, buildAddress: { __typename?: 'Address', id: string, street1: string } }
        | { __typename?: 'Structure', id: string, name: string, buildAddress: { __typename?: 'Address', id: string, street1: string } }
        | { __typename?: 'Unit', id: string, name: string, buildAddress: { __typename?: 'Address', id: string, street1: string } }
       } } };

export type PlanMilestoneDetailsPage_PlanMilestoneFragment = { __typename?: 'PlanMilestone', id: string, name: string, estStartDate?: Types.Scalars['Date']['input'] | null | undefined, estEndDate?: Types.Scalars['Date']['input'] | null | undefined, durationInDays: number, progress: number, confidence: number, allowingPlanTasks: Array<{ __typename?: 'PlanTask', id: string, name: string, startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], status: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string }, constraintItems: Array<{ __typename?: 'GlobalPlanConstraintItem', id: string }>, simulationProbability: { __typename?: 'SimulationProbability', endDateBasisPoints?: number | null | undefined } }>, planSchedule: { __typename?: 'PlanSchedule', id: string, parent:
      | { __typename?: 'StandaloneProject', id: string, name: string, buildAddress: { __typename?: 'Address', id: string, street1: string } }
      | { __typename?: 'Region', id: string, name: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined }
      | { __typename?: 'Market', id: string, name: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined }
      | { __typename?: 'Community', id: string, name: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined }
      | { __typename?: 'Subdivision', id: string, name: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined }
      | { __typename?: 'Lot', id: string, name: string, buildAddress: { __typename?: 'Address', id: string, street1: string } }
      | { __typename?: 'Structure', id: string, name: string, buildAddress: { __typename?: 'Address', id: string, street1: string } }
      | { __typename?: 'Unit', id: string, name: string, buildAddress: { __typename?: 'Address', id: string, street1: string } }
     } };

export type PlanMilestoneDetailsPage_PlanTaskFragment = { __typename?: 'PlanTask', id: string, name: string, startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], status: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string }, constraintItems: Array<{ __typename?: 'GlobalPlanConstraintItem', id: string }>, simulationProbability: { __typename?: 'SimulationProbability', endDateBasisPoints?: number | null | undefined } };

export const PlanMilestoneDetailsPage_PlanTaskFragmentDoc = gql`
    fragment PlanMilestoneDetailsPage_PlanTask on PlanTask {
  id
  name
  status {
    code
    name
  }
  constraintItems {
    id
  }
  startDate
  endDate
  simulationProbability {
    endDateBasisPoints
  }
}
    `;
export const PlanMilestoneDetailsPage_PlanMilestoneFragmentDoc = gql`
    fragment PlanMilestoneDetailsPage_PlanMilestone on PlanMilestone {
  id
  name
  estStartDate
  estEndDate
  durationInDays
  progress
  confidence
  allowingPlanTasks {
    ...PlanMilestoneDetailsPage_PlanTask
  }
  planSchedule {
    id
    parent {
      ... on Project {
        id
        name
        buildAddress {
          id
          street1
        }
      }
    }
  }
}
    ${PlanMilestoneDetailsPage_PlanTaskFragmentDoc}`;
export const PlanMilestoneDetailsPageDocument = gql`
    query PlanMilestoneDetailsPage($planMilestoneId: ID!) {
  planMilestone(id: $planMilestoneId) {
    ...PlanMilestoneDetailsPage_PlanMilestone
  }
}
    ${PlanMilestoneDetailsPage_PlanMilestoneFragmentDoc}`;

/**
 * __usePlanMilestoneDetailsPageQuery__
 *
 * To run a query within a React component, call `usePlanMilestoneDetailsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanMilestoneDetailsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanMilestoneDetailsPageQuery({
 *   variables: {
 *      planMilestoneId: // value for 'planMilestoneId'
 *   },
 * });
 */
export function usePlanMilestoneDetailsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanMilestoneDetailsPageQuery, PlanMilestoneDetailsPageQueryVariables> & ({ variables: PlanMilestoneDetailsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanMilestoneDetailsPageQuery, PlanMilestoneDetailsPageQueryVariables>(PlanMilestoneDetailsPageDocument, options);
      }
export function usePlanMilestoneDetailsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanMilestoneDetailsPageQuery, PlanMilestoneDetailsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanMilestoneDetailsPageQuery, PlanMilestoneDetailsPageQueryVariables>(PlanMilestoneDetailsPageDocument, options);
        }
// @ts-ignore
export function usePlanMilestoneDetailsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanMilestoneDetailsPageQuery, PlanMilestoneDetailsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanMilestoneDetailsPageQuery, PlanMilestoneDetailsPageQueryVariables>;
export function usePlanMilestoneDetailsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanMilestoneDetailsPageQuery, PlanMilestoneDetailsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanMilestoneDetailsPageQuery | undefined, PlanMilestoneDetailsPageQueryVariables>;
export function usePlanMilestoneDetailsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanMilestoneDetailsPageQuery, PlanMilestoneDetailsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanMilestoneDetailsPageQuery, PlanMilestoneDetailsPageQueryVariables>(PlanMilestoneDetailsPageDocument, options);
        }
export type PlanMilestoneDetailsPageQueryHookResult = ReturnType<typeof usePlanMilestoneDetailsPageQuery>;
export type PlanMilestoneDetailsPageLazyQueryHookResult = ReturnType<typeof usePlanMilestoneDetailsPageLazyQuery>;
export type PlanMilestoneDetailsPageSuspenseQueryHookResult = ReturnType<typeof usePlanMilestoneDetailsPageSuspenseQuery>;
export type PlanMilestoneDetailsPageQueryResult = Apollo.QueryResult<PlanMilestoneDetailsPageQuery, PlanMilestoneDetailsPageQueryVariables>;